export default __webpack_public_path__ + "static/media/liveChat.6b5fc7dd.mp3";